import { faBook, faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Menu, Hidden, IconButton, makeStyles, Step, StepLabel, Stepper as MUIStepper, Typography, useMediaQuery, useTheme, MenuItem, ListItemIcon, Divider, ListItemText } from '@material-ui/core';
import { ExitToApp, MenuSharp as IconMenu, Input } from '@material-ui/icons';
import clsx from 'clsx';
import { motion } from "framer-motion";
import { createRef, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { isAuthenticated, useUserState } from 'services/authentication.service';
import { useTrackEvent } from 'util/trackEvent';
import { AppPopup } from '../AppPopup';
import { HeaderPillow } from '../HeaderPillow';
import { STEP_STATE_COMPLETE, STEP_STATE_LIVE, STEP_STATE_PAYMENT, STEP_STATE_SCHEDULE, STEP_STATE_SUMMARY, bookingState, stepState } from '../RecoilState';
import { stepState as stepStateCreate } from 'pages/CustomerBookingCreate/state';
import './pulldown.scss'
import { useHistory } from 'react-router-dom';
import { STEP_BOOKING_LIST, STEP_SIGN_IN } from 'pages/CustomerBookingCreate/constants';
import { isPayable } from 'util/bookingStates';
const useStyles = makeStyles((theme) => {
  return {
    overlayPullDown: {
      top: -3,

      left: "calc(50% - 25px)",
      display: "flex",
      position: "absolute",
      justifyContent: "center",
      flexDirection: "row",
    },
    overlayPullup: {
      bottom: 0,
      width: "100%",
      display: "flex",
      position: "absolute",
      justifyContent: "center",
      flexDirection: "row",
    },
    overlay: {
      // zIndex: 1
    },
    wizardRoot: {
      position: 'relative',
      height: '100%',
      // zIndex: -1
    },
    wizardContent: {
      position: 'relative',
      // zIndex: -1
    },
    stepper: {
      [theme.breakpoints.down("xs")]: {
        paddingLeft: 0,
        paddingRight: 0
      }
    },
    popupPadding: {
      height: theme.spacing(8),
    },
    menuIcon: {
      position: 'absolute',
      zIndex: theme.zIndex.drawer + 1,
     
    }
  }
})
const WizardContent = ({
  onLogout = () => { },
  onPullUp = () => { },
  onCalcHeight = () => { },
  serviceId,
  current = 0,
  isMobile = false,
  children,
  StepComponent
}) => {
  const classes = useStyles()
  const currentStep = useRecoilValue(stepState)
  const [menuRefAnchor, setMenuRefAnchor] = useState(null);
  const localRef = createRef();

  const { logout } = useUserState()
  const history = useHistory()
  const trackEvent = useTrackEvent()
  const matches = useMediaQuery('(min-width:576px)');  //TODO: hacky recalculate height for unknown <576px css breakpoint adding a miscalculated wizard box height

  const [step, setStep] = useRecoilState(stepStateCreate);
  const enableMyBookingsReroute = process.env.REACT_APP_ENABLE_MY_BOOKINGS_REROUTE === 'true'

  useEffect(() => {
    onCalcHeight(localRef.current?.clientHeight)
  }, [localRef, matches]);

  const booking = useRecoilValue(bookingState)

  const steps = useMemo(() => {
    return [
      {
        label: 'Booking Details',
        visible: true,
        stepValue: STEP_STATE_SCHEDULE
      },
      {
        label: 'Add Payment',
        visible: isPayable(booking),
        stepValue: STEP_STATE_PAYMENT
      },
      {
        label: 'Booking Summary',
        visible: true,
        stepValue: STEP_STATE_SUMMARY
      },
      {
        label: 'Live Booking',
        visible: true,
        stepValue: STEP_STATE_LIVE
      },
      {
        label: 'Booking Complete',
        visible: true,
        stepValue: STEP_STATE_COMPLETE
      },

    ]

  }, [serviceId, booking]);

  const onLogoutClick = useCallback(
    () => {
      onLogout()
      setMenuRefAnchor(null)
    },
    [onLogout],
  );

  return (
    <div className={classes.wizardContent} ref={localRef}>
      {/* {isMobile && <AppPopup onClose={()=>setPopupClosed(true)}/>} */}
      {/* {(isMobile && !popupClosed) && (
          <div className={classes.popupPadding}/>
      )} */}
      <Hidden smUp>
        <IconButton color="secondary" className={classes.menuIcon} onClick={(evt) => setMenuRefAnchor(evt.currentTarget)}>
          <IconMenu fontSize='large' />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={menuRefAnchor}
          keepMounted
          open={Boolean(menuRefAnchor)}
          onClose={() => setMenuRefAnchor(null)}
        >
          {isAuthenticated() ? (
            <>
              {enableMyBookingsReroute ? (
                <>
                  <MenuItem onClick={() => {
                    trackEvent('Sidebar click my bookings')
                    history.push(STEP_BOOKING_LIST + history.location.search, { internal: true })
                    window.location.reload()
                    setMenuRefAnchor(null)
                  }}>
                    <ListItemIcon>
                      <FontAwesomeIcon icon={faBook} />
                    </ListItemIcon>
                    <ListItemText primary="My Bookings"
                      secondary='Go to your existing and booking history' />
                  </MenuItem>
                  <Divider />
                </>
              ) :
                (
                  <></>
                )}
              <MenuItem onClick={() => {
                trackEvent('Sidebar click Logout - mobile', {})
                onLogoutClick()
                setMenuRefAnchor(null)
              }}>
                <ListItemIcon>
                  <ExitToApp fontSize="small" />
                </ListItemIcon>
                <Typography variant="inherit" noWrap>
                  Log out
                </Typography>
              </MenuItem>
            </>
          ) : (
            <MenuItem onClick={() => {
              trackEvent('Sidebar click login - mobile', {})
              history.replace(STEP_SIGN_IN, { internal: true })
            }}>
              <ListItemIcon>
                <Input fontSize="small" />
              </ListItemIcon>
              <Typography variant="inherit" noWrap>
                Log In
              </Typography>
            </MenuItem>
          )
          }

        </Menu>
      </Hidden>
      <HeaderPillow whiteLabelPartner={booking?.white_label_partner} />
      {StepComponent ? StepComponent :
        (
          <MUIStepper nonLinear className={classes.stepper} activeStep={-1} orientation={isMobile ? "horizontal" : "vertical"} alternativeLabel={isMobile}>
            {steps?.filter(s=>s.visible)?.map((label) => (
              <Step key={label?.path}
                active={label?.stepValue === currentStep}
              >
                <StepLabel><Typography variant="caption">{label?.label}</Typography></StepLabel>
                
              </Step>
            ))}
          </MUIStepper>
        )}
    </div>
  )
}

const PullWizard = ({isCreate=false, ...props}) => {
  const classes = useStyles()
  const [calcHeight, setCalcHeight] = useState(0);
  const [isPullDown, setIsPullDown] = useState(true);
  const [animateVariant, setAnimateVariant] = useState('init');

  
  const isInit = useRef()
  const onCalcHeight = (value) => {
    setCalcHeight(value)
  }

  const trackEvent = useTrackEvent()
  const pullDownVariants = useMemo(() => {
    return {
      pullUp: {
        y: 0 - calcHeight,
        transition: { duration: 0.5 }
      },
      pullDown: {
        y: 0,
        transition: { duration: 0.5 }
      },
      init: {
        // y: -calcHeight, initially up
        y: 0,
        // height: `calc(100vh-${calcHeight}px)`,
        transition: { duration: 0 }
      },
    }
  }, [calcHeight]);

  const pullDownButtonVariants = useMemo(() => {
    return {
      pullUp: {
        y: 0,
        transition: { duration: 0.5 }
      },
      pullDown: {
        y: calcHeight,
        transition: { duration: 0.5 }
      },
      init: {
        // y: 0,  initially up
        y: calcHeight,
        transition: { duration: 0 }
      },
    }
  }, [calcHeight]);

  useEffect(() => {
    isInit.current = true
  }, [])

  const pullDown = useCallback(
    (pd) => {
      setIsPullDown(pd)
      let animateV = 'init'

      if (isInit.current) {
        animateV = (pd ? 'pullDown' : 'pullUp')
      } else {

      }
      setAnimateVariant(animateV)
    },
    [],
  );

  if (isCreate) {
    return <><WizardContent {...props} />{props.children}</>
  }

  if (!props?.isMobile) return <><WizardContent {...props} />{props.children}</>

  return (
    <div className={classes.wizardRoot}>
      <WizardContent {...props}
        onLogout={() => {
          props?.onLogout()
        }}
        onCalcHeight={onCalcHeight}
        onPullUp={() => pullDown(false)} />
      <motion.div
        variants={pullDownVariants}
        animate={animateVariant}
        transition={{ duration: 0 }}
        className={classes.overlay}>
        {props.children}
      </motion.div>

      <motion.div
        variants={pullDownButtonVariants}
        animate={animateVariant}
        transition={{ duration: 0 }}
        className={clsx('av-pulldown-button', classes.overlayPullDown)} onClick={() => {
          trackEvent(`Confirmation Steps Bar - ${isPullDown ? 'hide' : 'show'}`, {})
          pullDown(!isPullDown)
        }}><FontAwesomeIcon size={'xl'} icon={isPullDown ? faCaretUp : faCaretDown} />
      </motion.div>


    </div>
  )

}

export { PullWizard as Wizard };
